import React, { useState } from "react";
import { makePostCall } from "../../effects/requests";
import Button from "../../global/ui/Button";
import SignupControlledField from "../../global/ui/SignupControlledField";
import { setLocalStorage, showToast } from "../../utils";
import { apiConstants } from "../../utils/constants/apiConstants";
import endpoints from "../../utils/endpoints";
import { images } from "../../utils/constants/assets";
import { STRING_CONSTANTS } from "../../utils/constants/stringConstants";
import { parsePhoneNumber } from "libphonenumber-js";

interface SignUpFormProps {
  handleNext: () => void;
  control?: any;
  errors?: any;
  watch?: any;
  setValue?: any;
  getValues?: any;
  handlePrevious: () => void;
  isValid?: any;
  trigger?: () => Promise<boolean>;
}

export default function SignUpForm(props: SignUpFormProps) {
  const {
    control,
    errors,
    handleNext,
    handlePrevious,
    isValid,
    getValues,
    trigger,
  } = props;

  const [submitAttempted, setSubmitAttempted] = useState(false);
  const termsFieldKey = apiConstants.terms_check;

  const num = `${getValues(apiConstants.country_code)}${getValues(
    apiConstants.mobile_number
  )}`;

  const mobileNumber = num.toString().replace(/\s/g, "");
  const phoneNumber = parsePhoneNumber(mobileNumber);

  async function sendreginfo() {
    let apiPayload = {
      email: getValues(apiConstants.email),
      user_type: "C",
      mobile_number: phoneNumber.number,
      first_name: getValues(apiConstants.first_name),
      last_name: getValues(apiConstants.last_name),
    };

    try {
      const apiResponse = await makePostCall({
        url: endpoints.register,
        apiPayload,
      });

      const resp = await apiResponse;

      if (resp.status.code === 200) {
        handleNext();
      } else {
        showToast(resp.status.detail.email[0], "error");
        if (!resp.status.detail.email[0]) {
          showToast(resp.status.detail.email[0], "error");
        }
      }

      if (resp?.token?.access) {
        setLocalStorage("access_token", apiResponse?.token?.access);
      }
    } catch (err) {
      // showToast("fnn", "error");
    }
  }

  const sendsignupdata = async () => {
    setSubmitAttempted(true);
    if (trigger) {
      const valid = await trigger();
      if (!valid) {
        return;
      }
    }

    sendreginfo();
  };

  return (
    <div className="step_5 sign_up_screen otp_screen">
      <div className="upper-wrapper">
        <div className="back-logo">
          <div className="go-back" onClick={handlePrevious}>
            <img src={images.go_back} alt="" />
          </div>
        </div>
        <div className="Name form-field">
          <label htmlFor="firstname">First Name</label>
          <SignupControlledField
            name={apiConstants.first_name}
            type="text"
            control={control}
            errors={errors}
            id="firstname"
            submitAttempted={submitAttempted}
          />
        </div>
        <div className="Name form-field">
          <label htmlFor="lastname">Last Name</label>
          <SignupControlledField
            name={apiConstants.last_name}
            type="text"
            control={control}
            id="lastname"
            errors={errors}
            submitAttempted={submitAttempted}
          />
        </div>

        <div className="email form-field">
          <label htmlFor="emailid">Email Address</label>
          <SignupControlledField
            name={apiConstants.email}
            type="email"
            control={control}
            id="emailid"
            errors={errors}
            submitAttempted={submitAttempted}
          />
        </div>

        <div className="terms_agree custom_checkbox">
          <SignupControlledField
            name={apiConstants.terms_check}
            type="checkbox"
            control={control}
            hideErrorMessage
            id="terms"
          />
          <span className="checkmark"></span>
          <label htmlFor="terms">
            {STRING_CONSTANTS.signup_form}{" "}
            <a
              href="https://dev.unwritten.hair/policies/terms-of-service"
              rel="noopener noreferrer"
              target="_blank"
            >
              {STRING_CONSTANTS.terms}
            </a>{" "}
            &{" "}
            <a
              href="https://dev.unwritten.hair/policies/privacy-policy"
              rel="noopener noreferrer"
              target="_blank"
            >
              {STRING_CONSTANTS.privacy}
            </a>
            .
          </label>
        </div>
        {submitAttempted && errors?.[termsFieldKey]?.message && (
          <div className="signup-terms-error text-danger">
            {errors[termsFieldKey].message}
          </div>
        )}

        <div className="send_email custom_checkbox">
          <SignupControlledField
            name={apiConstants.email_reminders_opt_in}
            type="checkbox"
            control={control}
            hideErrorMessage
            id="reminders"
          />
          <span className="checkmark"></span>
          <label htmlFor="reminders">Send me email reminders & offers</label>
        </div>
      </div>
      <div className="bottom-wrapper">
        <Button
          className="continue-btn"
          type="submit"
          disabled={!isValid}
          btnTxt={"Sign Up"}
          isLoading={false}
          onClick={sendsignupdata}
        />
      </div>
    </div>
  );
}
